/**
 * Dados de referência de aeroportos e áreas metropolitanas usados pelo seletor (web) e pela busca de
 * preços (api). Estático e pequeno de propósito: cabe no bundle e funciona offline.
 * Para incluir um aeroporto, acrescente uma linha na lista certa (ordem alfabética por cidade).
 */
export interface AirportRef {
  code: string;
  city: string;
  name: string;
  country: string;
  /** Só em áreas metropolitanas: aeroportos agrupados, o principal primeiro. */
  airports?: string[];
}

export const METROS: AirportRef[] = [
  {
    code: 'BHZ',
    city: 'Belo Horizonte',
    name: 'Todos os aeroportos',
    country: 'Brasil',
    airports: ['CNF', 'PLU'],
  },
  {
    code: 'RIO',
    city: 'Rio de Janeiro',
    name: 'Todos os aeroportos',
    country: 'Brasil',
    airports: ['GIG', 'SDU'],
  },
  {
    code: 'SAO',
    city: 'São Paulo',
    name: 'Todos os aeroportos',
    country: 'Brasil',
    airports: ['GRU', 'CGH', 'VCP'],
  },
  {
    code: 'BUE',
    city: 'Buenos Aires',
    name: 'Todos os aeroportos',
    country: 'Argentina',
    airports: ['EZE', 'AEP'],
  },
  {
    code: 'LON',
    city: 'Londres',
    name: 'Todos os aeroportos',
    country: 'Reino Unido',
    airports: ['LHR', 'LGW', 'STN'],
  },
  { code: 'MIL', city: 'Milão', name: 'Todos os aeroportos', country: 'Itália', airports: ['MXP', 'LIN'] },
  {
    code: 'NYC',
    city: 'Nova York',
    name: 'Todos os aeroportos',
    country: 'Estados Unidos',
    airports: ['JFK', 'EWR', 'LGA'],
  },
  { code: 'PAR', city: 'Paris', name: 'Todos os aeroportos', country: 'França', airports: ['CDG', 'ORY'] },
  { code: 'ROM', city: 'Roma', name: 'Todos os aeroportos', country: 'Itália', airports: ['FCO', 'CIA'] },
  { code: 'TYO', city: 'Tóquio', name: 'Todos os aeroportos', country: 'Japão', airports: ['HND', 'NRT'] },
];

export const AIRPORTS: AirportRef[] = [
  // Brasil
  { code: 'AJU', city: 'Aracaju', name: 'Santa Maria', country: 'Brasil' },
  { code: 'BEL', city: 'Belém', name: 'Val de Cans', country: 'Brasil' },
  { code: 'CNF', city: 'Belo Horizonte', name: 'Confins', country: 'Brasil' },
  { code: 'PLU', city: 'Belo Horizonte', name: 'Pampulha', country: 'Brasil' },
  { code: 'BVB', city: 'Boa Vista', name: 'Atlas Brasil Cantanhede', country: 'Brasil' },
  { code: 'BSB', city: 'Brasília', name: 'Presidente Juscelino Kubitschek', country: 'Brasil' },
  { code: 'CPV', city: 'Campina Grande', name: 'Presidente João Suassuna', country: 'Brasil' },
  { code: 'VCP', city: 'Campinas', name: 'Viracopos', country: 'Brasil' },
  { code: 'CGR', city: 'Campo Grande', name: 'Campo Grande', country: 'Brasil' },
  { code: 'CXJ', city: 'Caxias do Sul', name: 'Hugo Cantergiani', country: 'Brasil' },
  { code: 'XAP', city: 'Chapecó', name: 'Serafin Enoss Bertaso', country: 'Brasil' },
  { code: 'CGB', city: 'Cuiabá', name: 'Marechal Rondon', country: 'Brasil' },
  { code: 'CWB', city: 'Curitiba', name: 'Afonso Pena', country: 'Brasil' },
  { code: 'FEN', city: 'Fernando de Noronha', name: 'Fernando de Noronha', country: 'Brasil' },
  { code: 'FLN', city: 'Florianópolis', name: 'Hercílio Luz', country: 'Brasil' },
  { code: 'FOR', city: 'Fortaleza', name: 'Pinto Martins', country: 'Brasil' },
  { code: 'IGU', city: 'Foz do Iguaçu', name: 'Cataratas', country: 'Brasil' },
  { code: 'GYN', city: 'Goiânia', name: 'Santa Genoveva', country: 'Brasil' },
  { code: 'IOS', city: 'Ilhéus', name: 'Jorge Amado', country: 'Brasil' },
  { code: 'IMP', city: 'Imperatriz', name: 'Prefeito Renato Moreira', country: 'Brasil' },
  { code: 'JPA', city: 'João Pessoa', name: 'Castro Pinto', country: 'Brasil' },
  { code: 'JOI', city: 'Joinville', name: 'Lauro Carneiro de Loyola', country: 'Brasil' },
  { code: 'JDO', city: 'Juazeiro do Norte', name: 'Orlando Bezerra de Menezes', country: 'Brasil' },
  { code: 'LDB', city: 'Londrina', name: 'Governador José Richa', country: 'Brasil' },
  { code: 'MCP', city: 'Macapá', name: 'Alberto Alcolumbre', country: 'Brasil' },
  { code: 'MCZ', city: 'Maceió', name: 'Zumbi dos Palmares', country: 'Brasil' },
  { code: 'MAO', city: 'Manaus', name: 'Eduardo Gomes', country: 'Brasil' },
  { code: 'MGF', city: 'Maringá', name: 'Sílvio Name Júnior', country: 'Brasil' },
  { code: 'MOC', city: 'Montes Claros', name: 'Mário Ribeiro', country: 'Brasil' },
  { code: 'NAT', city: 'Natal', name: 'São Gonçalo do Amarante', country: 'Brasil' },
  { code: 'NVT', city: 'Navegantes', name: 'Ministro Victor Konder', country: 'Brasil' },
  { code: 'PMW', city: 'Palmas', name: 'Brigadeiro Lysias Rodrigues', country: 'Brasil' },
  { code: 'PNZ', city: 'Petrolina', name: 'Senador Nilo Coelho', country: 'Brasil' },
  { code: 'POA', city: 'Porto Alegre', name: 'Salgado Filho', country: 'Brasil' },
  { code: 'BPS', city: 'Porto Seguro', name: 'Porto Seguro', country: 'Brasil' },
  { code: 'PVH', city: 'Porto Velho', name: 'Governador Jorge Teixeira', country: 'Brasil' },
  { code: 'REC', city: 'Recife', name: 'Guararapes', country: 'Brasil' },
  { code: 'RAO', city: 'Ribeirão Preto', name: 'Leite Lopes', country: 'Brasil' },
  { code: 'RBR', city: 'Rio Branco', name: 'Plácido de Castro', country: 'Brasil' },
  { code: 'GIG', city: 'Rio de Janeiro', name: 'Galeão', country: 'Brasil' },
  { code: 'SDU', city: 'Rio de Janeiro', name: 'Santos Dumont', country: 'Brasil' },
  { code: 'SSA', city: 'Salvador', name: 'Deputado Luís Eduardo Magalhães', country: 'Brasil' },
  { code: 'STM', city: 'Santarém', name: 'Maestro Wilson Fonseca', country: 'Brasil' },
  { code: 'SJP', city: 'São José do Rio Preto', name: 'Professor Eribelto Manoel Reino', country: 'Brasil' },
  { code: 'SLZ', city: 'São Luís', name: 'Marechal Cunha Machado', country: 'Brasil' },
  { code: 'CGH', city: 'São Paulo', name: 'Congonhas', country: 'Brasil' },
  { code: 'GRU', city: 'São Paulo', name: 'Guarulhos', country: 'Brasil' },
  { code: 'THE', city: 'Teresina', name: 'Senador Petrônio Portella', country: 'Brasil' },
  { code: 'UDI', city: 'Uberlândia', name: 'Ten. Cel. Aviador César Bombonato', country: 'Brasil' },
  { code: 'VIX', city: 'Vitória', name: 'Eurico de Aguiar Salles', country: 'Brasil' },
  // Mundo
  { code: 'AMS', city: 'Amsterdã', name: 'Schiphol', country: 'Países Baixos' },
  { code: 'ATH', city: 'Atenas', name: 'Eleftherios Venizelos', country: 'Grécia' },
  { code: 'ATL', city: 'Atlanta', name: 'Hartsfield-Jackson', country: 'Estados Unidos' },
  { code: 'BCN', city: 'Barcelona', name: 'El Prat', country: 'Espanha' },
  { code: 'BER', city: 'Berlim', name: 'Brandemburgo', country: 'Alemanha' },
  { code: 'BOG', city: 'Bogotá', name: 'El Dorado', country: 'Colômbia' },
  { code: 'BOS', city: 'Boston', name: 'Logan', country: 'Estados Unidos' },
  { code: 'BRU', city: 'Bruxelas', name: 'Zaventem', country: 'Bélgica' },
  { code: 'AEP', city: 'Buenos Aires', name: 'Aeroparque', country: 'Argentina' },
  { code: 'EZE', city: 'Buenos Aires', name: 'Ezeiza', country: 'Argentina' },
  { code: 'CUN', city: 'Cancún', name: 'Cancún', country: 'México' },
  { code: 'CPT', city: 'Cidade do Cabo', name: 'Cidade do Cabo', country: 'África do Sul' },
  { code: 'MEX', city: 'Cidade do México', name: 'Benito Juárez', country: 'México' },
  { code: 'PTY', city: 'Cidade do Panamá', name: 'Tocumen', country: 'Panamá' },
  { code: 'CPH', city: 'Copenhague', name: 'Kastrup', country: 'Dinamarca' },
  { code: 'CUR', city: 'Curaçao', name: 'Hato', country: 'Curaçao' },
  { code: 'CTG', city: 'Cartagena', name: 'Rafael Núñez', country: 'Colômbia' },
  { code: 'ORD', city: 'Chicago', name: "O'Hare", country: 'Estados Unidos' },
  { code: 'DFW', city: 'Dallas', name: 'Dallas/Fort Worth', country: 'Estados Unidos' },
  { code: 'DOH', city: 'Doha', name: 'Hamad', country: 'Catar' },
  { code: 'DUB', city: 'Dublin', name: 'Dublin', country: 'Irlanda' },
  { code: 'DXB', city: 'Dubai', name: 'Dubai', country: 'Emirados Árabes' },
  { code: 'EDI', city: 'Edimburgo', name: 'Edimburgo', country: 'Reino Unido' },
  { code: 'FLL', city: 'Fort Lauderdale', name: 'Hollywood', country: 'Estados Unidos' },
  { code: 'FRA', city: 'Frankfurt', name: 'Frankfurt', country: 'Alemanha' },
  { code: 'GVA', city: 'Genebra', name: 'Genebra', country: 'Suíça' },
  { code: 'IST', city: 'Istambul', name: 'Istambul', country: 'Turquia' },
  { code: 'LIM', city: 'Lima', name: 'Jorge Chávez', country: 'Peru' },
  { code: 'LIS', city: 'Lisboa', name: 'Humberto Delgado', country: 'Portugal' },
  { code: 'LGW', city: 'Londres', name: 'Gatwick', country: 'Reino Unido' },
  { code: 'LHR', city: 'Londres', name: 'Heathrow', country: 'Reino Unido' },
  { code: 'STN', city: 'Londres', name: 'Stansted', country: 'Reino Unido' },
  { code: 'LAS', city: 'Las Vegas', name: 'Harry Reid', country: 'Estados Unidos' },
  { code: 'LAX', city: 'Los Angeles', name: 'Los Angeles', country: 'Estados Unidos' },
  { code: 'MAD', city: 'Madri', name: 'Barajas', country: 'Espanha' },
  { code: 'MIA', city: 'Miami', name: 'Miami', country: 'Estados Unidos' },
  { code: 'LIN', city: 'Milão', name: 'Linate', country: 'Itália' },
  { code: 'MXP', city: 'Milão', name: 'Malpensa', country: 'Itália' },
  { code: 'MVD', city: 'Montevidéu', name: 'Carrasco', country: 'Uruguai' },
  { code: 'MUC', city: 'Munique', name: 'Franz Josef Strauss', country: 'Alemanha' },
  { code: 'NCE', city: 'Nice', name: "Côte d'Azur", country: 'França' },
  { code: 'EWR', city: 'Nova York', name: 'Newark', country: 'Estados Unidos' },
  { code: 'JFK', city: 'Nova York', name: 'John F. Kennedy', country: 'Estados Unidos' },
  { code: 'LGA', city: 'Nova York', name: 'LaGuardia', country: 'Estados Unidos' },
  { code: 'MCO', city: 'Orlando', name: 'Orlando', country: 'Estados Unidos' },
  { code: 'CDG', city: 'Paris', name: 'Charles de Gaulle', country: 'França' },
  { code: 'ORY', city: 'Paris', name: 'Orly', country: 'França' },
  { code: 'OPO', city: 'Porto', name: 'Francisco Sá Carneiro', country: 'Portugal' },
  { code: 'PRG', city: 'Praga', name: 'Václav Havel', country: 'Tchéquia' },
  { code: 'PUJ', city: 'Punta Cana', name: 'Punta Cana', country: 'República Dominicana' },
  { code: 'CIA', city: 'Roma', name: 'Ciampino', country: 'Itália' },
  { code: 'FCO', city: 'Roma', name: 'Fiumicino', country: 'Itália' },
  { code: 'SFO', city: 'San Francisco', name: 'San Francisco', country: 'Estados Unidos' },
  { code: 'SCL', city: 'Santiago', name: 'Arturo Merino Benítez', country: 'Chile' },
  { code: 'SDQ', city: 'Santo Domingo', name: 'Las Américas', country: 'República Dominicana' },
  { code: 'HND', city: 'Tóquio', name: 'Haneda', country: 'Japão' },
  { code: 'NRT', city: 'Tóquio', name: 'Narita', country: 'Japão' },
  { code: 'YYZ', city: 'Toronto', name: 'Pearson', country: 'Canadá' },
  { code: 'VCE', city: 'Veneza', name: 'Marco Polo', country: 'Itália' },
  { code: 'VIE', city: 'Viena', name: 'Schwechat', country: 'Áustria' },
  { code: 'ZRH', city: 'Zurique', name: 'Zurique', country: 'Suíça' },
];

const ALL = [...METROS, ...AIRPORTS];
const BY_CODE = new Map(ALL.map((a) => [a.code, a]));

export function findPlace(code: string): AirportRef | undefined {
  return BY_CODE.get(code.toUpperCase());
}

/** Área metropolitana de um aeroporto, se houver (GRU → SAO). */
export function metroOf(airportCode: string): AirportRef | undefined {
  return METROS.find((m) => m.airports?.includes(airportCode.toUpperCase()));
}

/**
 * Aeroportos a consultar para um lugar.
 * - Área metropolitana: todos (agrupado) ou só o principal.
 * - Aeroporto: ele mesmo, ou todos da área quando "Todos os aeroportos" está ligado.
 */
export function airportsToQuery(code: string, groupAirports: boolean): string[] {
  const upper = code.toUpperCase();
  const place = BY_CODE.get(upper);
  if (place?.airports) return groupAirports ? place.airports : [place.airports[0]!];
  if (groupAirports) {
    const metro = metroOf(upper);
    if (metro?.airports) return metro.airports;
  }
  return [upper];
}

/** Linha de apoio do campo, no formato do design system: "SAO · GRU, CGH e VCP" ou "LIS · Portugal". */
export function placeDetail(place: AirportRef): string {
  if (place.airports) return `${place.code} · ${joinPt(place.airports)}`;
  return `${place.code} · ${place.name === place.city ? place.country : place.name}`;
}

function joinPt(items: string[]): string {
  if (items.length <= 1) return items.join('');
  return `${items.slice(0, -1).join(', ')} e ${items[items.length - 1]}`;
}

const normalize = (s: string) =>
  s
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLowerCase()
    .trim();

/** Busca por código, cidade ou nome, sem acento. Código exato primeiro, depois áreas metropolitanas. */
export function searchPlaces(query: string, limit = 12): AirportRef[] {
  const q = normalize(query);
  if (!q) return METROS.filter((m) => m.country === 'Brasil');
  const scored: { a: AirportRef; score: number }[] = [];
  for (const a of ALL) {
    const code = a.code.toLowerCase();
    const city = normalize(a.city);
    const name = normalize(a.name);
    let score = -1;
    if (code === q) score = 0;
    else if (city.startsWith(q)) score = 1;
    else if (code.startsWith(q)) score = 2;
    else if (name.startsWith(q) || city.includes(q)) score = 3;
    else if (name.includes(q) || normalize(a.country).startsWith(q)) score = 4;
    if (score >= 0) scored.push({ a, score: score + (a.airports ? -0.5 : 0) });
  }
  scored.sort((x, y) => x.score - y.score || x.a.city.localeCompare(y.a.city, 'pt-BR'));
  return scored.slice(0, limit).map((s) => s.a);
}
